import DemandStudioDocumentView from "./DemandStudioDocumentView";
import DemandStudioRevisionComments from "./DemandStudioRevisionComments";
import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import { TOUR_TARGETS } from "../../constants/tourTargets";

const twoColClasses = "grid grid-cols-[1.5fr_480px] gap-8 h-full min-h-0";

const scrollbarClasses =
  "[&::-webkit-scrollbar]:w-0.5 " +
  "[&::-webkit-scrollbar-track]:bg-transparent " +
  "[&::-webkit-scrollbar-thumb]:bg-border " +
  "[&::-webkit-scrollbar-thumb]:rounded-full";

const colLeftClasses = `overflow-y-auto min-h-0 pr-2 pb-6 ${scrollbarClasses}`;

const documentWrapperBase =
  "bg-white border border-border rounded-2xl p-6 min-h-full";

const documentWrapperTabsClasses = "pt-0! rounded-tl-none! rounded-tr-none!";

const DemandStudioEditor = () => {
  const { isTabView } = useDemandStudioContext();

  return (
    <div className={twoColClasses}>
      <div className={colLeftClasses}>
        <div
          data-tour={TOUR_TARGETS.DEMAND_STUDIO_DOCUMENT}
          className={`${documentWrapperBase} ${isTabView ? documentWrapperTabsClasses : ""}`}
        >
          <DemandStudioDocumentView />
        </div>
      </div>
      <DemandStudioRevisionComments />
    </div>
  );
};

export default DemandStudioEditor;
